"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty";

export const NFTHistoryEmpty = () => {
  const t = useTranslations("checkout");

  const handleStartPurchase = () => {
    window.location.hash = "projects";
  };

  return (
    <Empty className="h-[40vh] flex flex-col items-center justify-between">
      <EmptyHeader>
        <EmptyMedia variant="default">
          <Image
            src="/images/ui/empty-cart.webp"
            alt="empty-history"
            width={150}
            height={150}
            className="object-cover"
          />
        </EmptyMedia>
        <EmptyTitle className="text-sm font-normal">
          {t("nftHistory.emptyTitle")}
        </EmptyTitle>
      </EmptyHeader>
      <EmptyContent>
        <EmptyDescription className="text-base text-text-primary">
          {t("nftHistory.emptyBody")}
        </EmptyDescription>
        <Button colors={"primary"} onClick={handleStartPurchase}>
          {t("nftHistory.startPurchase")}
        </Button>
      </EmptyContent>
    </Empty>
  );
};
